import { styled } from "@mui/material";
import Card from "@mui/material/Card";

export const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(5),
  marginTop: theme.spacing(2),
  width: "100%",
}));
